import { Component, Vue, Watch } from "vue-property-decorator";
import WithRender from "./MonitorDashboardPage.html";
import Requests from "./Requests/Requests";
import Notifications330Page from "./Notifications330/Notifications330Page";

@WithRender
@Component({
    components: {
        Requests,
        Notifications330Page,
    },
})
export default class MonitorDashboardPage extends Vue {
    public topTab: number = 0;

    public async mounted(): Promise<void> {
        const q = this.$route.query;
        if (q && q.topTab != null && String(q.topTab) !== "") {
            const tab = parseInt(String(q.topTab), 10);
            if (!isNaN(tab)) {
                this.topTab = tab;
            }
        }
    }

    @Watch("topTab")
    public async onTopTabChanged(): Promise<void> {
        await this.$nextTick();
        await this.refreshActive();
    }

    private async refreshActive(): Promise<void> {
        if (this.topTab === 0) {
            const cmp: any = this.$refs.requestsPage;
            if (cmp && cmp.refresh) {
                await cmp.refresh();
            }
            return;
        }

        if (this.topTab === 1) {
            const cmp: any = this.$refs.notifications330Page;
            if (cmp && cmp.refresh) {
                await cmp.refresh();
            }
            return;
        }
    }
}
